/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable */
/*  eslint-disable @typescript-eslint/no-use-before-define */
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { useDispatch, useSelector } from 'react-redux';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Spinner from '@salesforce/design-system-react/components/spinner';
import Button from '@salesforce/design-system-react/components/button';
import Tabs from '@salesforce/design-system-react/components/tabs';
import TabsPanel from '@salesforce/design-system-react/components/tabs/panel';
import moment from 'moment';
import { LIMIT, NEXT_DATA, PREV_DATA, RETURN_SCREEN_TYPE } from '../../../util/constants';
import './index.scss';
import InventoryReturnFilter from './InventoryReturnFilter';
import InventoryReturn from './InventoryReturn/InventoryReturn';
import { GET_FORM_CONFIGURATIONS } from '../../../graphql/getFormConfigurations';
import { GET_ORDER_LIST } from '../../../graphql/getOrderList';
import { GET_INVENTORY_RETURN_LIST } from '../../../graphql/getInventoryReturnsList';
import CancelEventModal from '../../CreateEditSurgeryEvent/CancelEventCreationModal';
import debounced from '../../../util/debounced';
import FilterTags from '../../Shared/FilterTags';
import ReturnDataTable from './ReturnDataTable';
import ReturnHeader from './ReturnHeader';
import {
  clearInventoryReturnsFilters,
  getInventoryReturnsFilters,
  setInventoryReturnsFilters,
} from '../../../store/ducks/inventoryReturnsFilters';
import { setHoldBannerStatus } from '../../../store/ducks/holdBanner';
import { GET_USER_HOLD } from '../../../graphql/getUserHold';
import { getUserInfo } from '../../../store/ducks/userInfo';
import { GET_FILTER_PRESETS } from '../../../graphql/getFilterPresets';
import { SHOW_AGENCY_RECORDS, SHOW_STRYKER_RECORDS } from '../../../util/constants';
import paginateData from '../../../util/commonHelper';
import inventoryHelper from '../../../util/inventoryReturnHelper';
import { GET_DEFAULT_SUB_INVENTORY_ACCOUNT_MAPPING } from '../../../graphql/getDefaultSubInventoryAccountMapping';
import { GET_SALES_REPS } from '../../../graphql/getSalesReps';
import { getFormattedHoldReasons } from '../../../util/formatHoldReasons';

export interface Item {
  orderId: string;
  externalId: string;
  orderExternalId: string;
  salesRepId: string;
  assignedOPSId: string;
  status: string;
  type: string;
  createdDate: string;
  orderNumber: string;
  effectiveDate: string;
  fromSubInventoryCode: string;
  toSubInventoryCode: string;
  recordTypeId: string;
  priceBook2Id: string;
  salesOrganization: string;
  accountId: string;
  accountNumber: string;
  accountName: string;
  salesRepName: string;
  assignedOPSName: string;
  visualIndicator: string;
  shipmentDate: string;
  shippingMethod: string;
  trackingNumber: string;
  returnReason: string;
  returnExpiryDate: string;
  comments: [];
  lineItems: any;
}
interface DynamicValue {
  [key: string]: any;
}
interface SelectedData {
  id: string;
  label: string;
  __typename?: string;
}
interface FilterPreset {
  filterValues: Filter;
  filterExternalId?: string;
  filterName?: string;
}
interface Filter {
  search?: string;
  status: SelectedData[];
  submitToDate: Date | string;
  submitFromDate: Date | string;
}
interface Filters {
  search?: string;
  status?: string[];
  submitToDate?: Date | string;
  submitFromDate?: Date | string;
}
interface Props extends RouteComponentProps {
  history: any;
}

const InventoryReturns: FC<Props> = ({ history }) => {
  const { pathname } = history.location;
  const dispatch = useDispatch();
  const [sortColumn, setSortColumn] = useState<any>();
  const userInfo = useSelector(getUserInfo);

  const statusUrl = pathname.slice(pathname.lastIndexOf('/') + 1, pathname.length);
  // const [status, setStatus] = useState('RETURNS')
  const [status, setStatus] = useState(
    ['RETURNS', 'COMPLETED', 'FAILED'].indexOf(statusUrl.toUpperCase()) >= 0
      ? statusUrl.toUpperCase()
      : 'RETURNS'
  );
  const [openReturnCompletedFilter, setOpenReturnCompletedFilter] = useState(false);
  const [cancelModalVisible, setCancelModalVisible] = useState(false);
  const [openReturnFilter, setOpenReturnFilter] = useState(false);
  const [openNewReturnModal, setOpenNewReturnModal] = useState(false);
  const [openNewPickupReturnModal, setOpenNewPickupReturnModal] = useState(false);
  const [returnsType, setReturnsType] = useState('');
  const [updatedSelectedFilter, setUpdatedSelectedFilter] = useState<
    FilterPreset | DynamicValue | null
  >(null);
  const [selectedFilter, setSelectedFilter] = useState<FilterPreset | DynamicValue | null>(null);
  const [returnCompletedItems, setReturnCompletedItems] = useState<any[] | null>();
  const [
    getInventoryReturnListItems,
    { data: inventoryReturnItems, loading: loadingInventoryReturnItems },
  ] = useLazyQuery(GET_INVENTORY_RETURN_LIST, { fetchPolicy: 'cache-and-network' });

  const [
    getInventoryReturnListCompletedItems,
    { data: inventoryReturnCompletedItems, loading: loadingInventoryReturnCompletedItems },
  ] = useLazyQuery(GET_INVENTORY_RETURN_LIST, { fetchPolicy: 'cache-and-network' });

  const [getFormConfigurations, { data }] = useLazyQuery(GET_FORM_CONFIGURATIONS, {
    fetchPolicy: 'cache-first',
  });

  const inventoryReturnListData = inventoryReturnItems?.getInventoryReturnList;
  const [offsetFailed, setOffsetFailed] = useState(0);
  const [offsetReturns, setOffsetReturns] = useState(0);
  const [offsetCompleted, setOffsetCompleted] = useState(0);
  const [isManualPagination, setIsManualPagination] = useState(false);
  const [isFilteredApply, setIsFilteredApply] = useState(false);

  const [selectedFilterApiValues, setSelectedFilterApiValues] = useState<Filters | null>(null);
  const [filterEventModalVisible, setFilterEventModalVisible] = useState(false);
  const [isEditFilter, setIsEditFilter] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { data: filterPresets, refetch: refetchFilterPresets } = useQuery(GET_FILTER_PRESETS, {
    variables: {
      userId: userInfo?.id,
      type: pathname.toLowerCase().includes('/inventory/requests') ? 'Request' : 'Returns',
    },
  });
  const filterData = filterPresets?.getFilterPresets;

  const { data: userHoldData } = useQuery(GET_USER_HOLD, {
    fetchPolicy: 'no-cache',
    variables: {
      id: userInfo?.id,
    },
  });
  useEffect(() => {
    dispatch(setHoldBannerStatus(false));
  }, [dispatch]);
  useEffect(() => {
    getFormConfigurations();
  }, [getFormConfigurations]);

  const [
    getInventoryRequestListFailedItems,
    { data: inventoryRequestFailedItems, loading: loadingInventoryRequestFailedItems },
  ] = useLazyQuery(GET_ORDER_LIST, { fetchPolicy: 'cache-first' });
  const inventoryReturnFailedListData = inventoryRequestFailedItems?.getOrderList;

  const [
    getInventoryRequestListProgressItems,
    { data: inventoryRequestProgressItems, loading: loadingInventoryRequestProgressItems },
  ] = useLazyQuery(GET_ORDER_LIST, { fetchPolicy: 'cache-first' });
  const inventoryReturnCompletedListData = inventoryRequestProgressItems?.getOrderList;

  const { data: salesRepsItems, loading: salesRepsLoading } = useQuery(GET_SALES_REPS, {
    fetchPolicy: 'cache-first',
  });
  const {
    data: defaultSubInventoryAccountResponse,
    loading: defaultSubInventoryAccountLoading,
  } = useQuery(GET_DEFAULT_SUB_INVENTORY_ACCOUNT_MAPPING, {
    variables: {
      businessUnit: userInfo?.businessunit,
      orderType: returnsType,
    },
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    const loadingStates = [
      salesRepsLoading,
      defaultSubInventoryAccountLoading,
      loadingInventoryReturnItems,
      loadingInventoryRequestFailedItems,
      loadingInventoryRequestProgressItems,
      loadingInventoryReturnCompletedItems,
    ];

    setIsLoading(loadingStates.some(state => state));
  }, [
    salesRepsLoading,
    defaultSubInventoryAccountLoading,
    loadingInventoryReturnItems,
    loadingInventoryRequestFailedItems,
    loadingInventoryRequestProgressItems,
    loadingInventoryReturnCompletedItems,
  ]);

  useEffect(() => {
    setOffsetReturns(0);
    setOffsetCompleted(0);
    if (status === 'FAILED') {
      getInventoryRequestListFailedItems({
        variables: {
          offset: 0,
          limit: LIMIT,
          orderType: 'INVENTORY_RETURN',
          screenType: status,
          ...(selectedFilter && { filters: selectedFilter }),
        },
      });
    } else if (status === 'COMPLETED') {
      getInventoryRequestListProgressItems({
        variables: {
          offset: 0,
          limit: LIMIT,
          orderType: 'INVENTORY_RETURN',
          screenType: 'PROCESSED',
          ...(selectedFilter && { filters: selectedFilter }),
        },
      });
    } else {
      getInventoryReturnListItems({
        variables: {
          offset: 0,
          limit: LIMIT,
          type: status,
        },
      });
    }
  }, [
    status,
  ]);

  useEffect(() => {
    const currentStateLength = returnCompletedItems?.length || 0;
    const newDataLength = inventoryRequestProgressItems?.getOrderList?.length || 0;
    
    if (inventoryRequestProgressItems?.getOrderList && newDataLength > 0) {
      const shouldUpdate = newDataLength !== currentStateLength || isManualPagination || isFilteredApply;
      
      if (shouldUpdate) {
        const list = getFormattedList(inventoryRequestProgressItems?.getOrderList);
        let prevAndCurrent;

        if (isManualPagination === false && isFilteredApply === true) {
          prevAndCurrent = [...(returnCompletedItems ?? []), ...list];
        } else {
          prevAndCurrent = [...list];
        }

        setReturnCompletedItems(prevAndCurrent);
      }
    }
  }, [inventoryRequestProgressItems?.getOrderList?.length, isManualPagination, isFilteredApply]);

  const filterStore = useSelector(getInventoryReturnsFilters);

  useEffect(() => {
    const setFilters = JSON.parse(filterStore || '{}');

    if (setFilters && setFilters.filterValues) {
      setUpdatedSelectedFilter(setFilters);
      setSelectedFilter(setFilters);
      setSelectedFilterApiValues(setFilters);
      const filters = getFilterApiValue(setFilters.filterValues);
      delete filters.search;
      handleRefetchItems(filters);
    }
  }, [status]);

  const routeToInventoryReturnDetail = (externalId: string): void => {
    history.push('/inventoryReturnDetails', {
      externalId,
    });
  };

  const handleCompletedTab = (e: any): void => {
    setSelectedFilter(null);
    setUpdatedSelectedFilter(null);
    if (e === 0) {
      setStatus('RETURNS');
      history.push('/inventory/Returns/return');
    } else if (e === 1) {
      setStatus('FAILED');
      history.push('/inventory/Returns/failed');
    } else if (e === 2) {
      setStatus('COMPLETED');
      history.push('/inventory/Returns/completed');
    }
  };

  const sortedcolumn = (property: any): void => {
    setSortColumn(property);
  };

  const handlePaginationButtonClicked = (type: string): void => {
    let finalOffset;
    if (status === 'RETURNS') {
      if (type === NEXT_DATA) {
        finalOffset = offsetReturns + LIMIT;
      } else {
        finalOffset = offsetReturns - LIMIT;
      }
      if (sortColumn) {
        const sortProperty = sortColumn.property;
        const { sortDirection } = sortColumn;
        getInventoryReturnListItems({
          variables: {
            limit: LIMIT,
            orderBy: sortProperty,
            orderSortType: sortDirection,
            offset: finalOffset,
            type: status,
            ...(selectedFilter && { filters: getFilterApiValue(selectedFilter.filterValues) }),
          },
        });
      } else {
        getInventoryReturnListItems({
          variables: {
            offset: finalOffset,
            limit: LIMIT,
            type: status,
            ...(selectedFilter && { filters: getFilterApiValue(selectedFilter.filterValues) }),
          },
        });
      }
      setOffsetReturns(finalOffset);
    } else if (status === 'COMPLETED') {
      let filterParams = selectedFilter
        ? { filters: getFilterApiValue(selectedFilter.filterValues) }
        : {};
      let isFilteredApplyLocal =
        filterParams &&
        filterParams.filters &&
        Array.isArray(filterParams.filters.status) &&
        filterParams.filters.status.length > 0;

      let ispagination5000Plus50 = false;

      const CHUNK_SIZE = 5000;

      if (type === NEXT_DATA) {
        finalOffset = offsetCompleted + LIMIT;
        // example 4950 → 5000, 9950 → 10000 etc.
        ispagination5000Plus50 = finalOffset % CHUNK_SIZE === 0 && finalOffset !== 0;
      } else {
        finalOffset = offsetCompleted - LIMIT;
        // No need to maintaine the logic for,
        // we are always appending previous results to current to avoid re call the api
      }

      const maxFetchedOffset = returnCompletedItems?.length || 0;
      const shouldFetchFromServer = finalOffset >= maxFetchedOffset;
      const isPagNoApi =
        isFilteredApplyLocal && (!ispagination5000Plus50 || !shouldFetchFromServer);

      if (isPagNoApi) {
        // below code will handle pagination if filtered apply in ReturnDataTable
      } else if (sortColumn) {
        const sortProperty = sortColumn.property;
        const { sortDirection } = sortColumn;
        getInventoryRequestListProgressItems({
          variables: {
            limit: LIMIT,
            orderBy: sortProperty,
            orderSortType: sortDirection,
            offset: finalOffset,
            orderType: 'INVENTORY_RETURN',
            screenType: 'PROCESSED',
            ...filterParams,
          },
        });
      } else {
        getInventoryRequestListProgressItems({
          variables: {
            offset: finalOffset,
            limit: LIMIT,
            orderType: 'INVENTORY_RETURN',
            screenType: 'PROCESSED',
            ...filterParams,
          },
        });
      }

      setIsFilteredApply(isFilteredApplyLocal || false);
      setIsManualPagination(isPagNoApi || false);
      setOffsetCompleted(finalOffset);
    } else if (status === 'FAILED') {
      if (type === NEXT_DATA) {
        finalOffset = offsetFailed + LIMIT;
      } else {
        finalOffset = offsetFailed - LIMIT;
      }

      if (sortColumn) {
        const sortProperty = sortColumn.property;
        const { sortDirection } = sortColumn;
        getInventoryRequestListFailedItems({
          variables: {
            limit: LIMIT,
            orderBy: sortProperty,
            orderSortType: sortDirection,
            offset: finalOffset,
            orderType: 'INVENTORY_RETURN',
            screenType: status,
            ...(selectedFilter && { filters: getFilterApiValue(selectedFilter.filterValues) }),
          },
        });
      } else {
        getInventoryRequestListFailedItems({
          variables: {
            offset: finalOffset,
            limit: LIMIT,
            orderType: 'INVENTORY_RETURN',
            screenType: status,
            // ...(selectedFilter && { filters: selectedFilter }),
          },
        });
      }
      setOffsetCompleted(finalOffset);
    }
  };

  const handleReturnsFilter = (): void => {
    setSelectedFilter(updatedSelectedFilter);
    setOpenReturnFilter(!openReturnFilter);
  };

  const handleReturnCompletedFilter = (): void => {
    setOpenReturnCompletedFilter(!openReturnCompletedFilter);
  };

  const handleRequestCompletedFilterModal = (): void => {
    setOpenReturnCompletedFilter(!openReturnCompletedFilter);
  };

  const handleFilterModal = (): void => {
    handleEditFilter(false);
    setOpenReturnFilter(!openReturnFilter);
  };

  const handleRefetchItems = (filterData: Filters | null): void => {
    setOffsetReturns(0);
    setOffsetCompleted(0);
    if (status === 'FAILED') {
      getInventoryRequestListFailedItems({
        variables: {
          offset: 0,
          limit: LIMIT,
          orderType: 'INVENTORY_RETURN',
          screenType: status,
          ...(filterData && { filters: filterData }),
        },
      });
    } else if (status === 'COMPLETED') {
      getInventoryRequestListProgressItems({
        variables: {
          offset: 0,
          limit: LIMIT,
          orderType: 'INVENTORY_RETURN',
          screenType: 'PROCESSED',
          ...(filterData && { filters: filterData }),
        },
      });
    } else {
      getInventoryReturnListItems({
        variables: {
          offset: 0,
          limit: LIMIT,
          type: status,
          ...(filterData && { filters: filterData }),
        },
      });
    }
  };

  const getFilterApiValue = (filterValues: DynamicValue): Filters => {
    let reducedFilterValues = {};

    if (filterValues) {
      Object.keys(filterValues).forEach((key: string) => {
        if (Array.isArray(filterValues[key])) {
          let values;
          values = filterValues[key].map((item: SelectedData) => item.id);
          if (values && values.length > 0) {
            reducedFilterValues = { ...reducedFilterValues, [key]: [...values] };
          }
        } else if (Array.isArray(filterValues[key]) && filterValues[key]) {
          if (filterValues[key].length > 0) {
            reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key] };
          }
        } else if (key !== '__typename' && filterValues[key]) {
          reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key] };
        } else if (key === SHOW_AGENCY_RECORDS || key === SHOW_STRYKER_RECORDS) {
          reducedFilterValues = { ...reducedFilterValues, [key]: filterValues[key] || false };
        }
      });
      const filterData = { ...reducedFilterValues };
      return filterData;
    }
    return {};
  };

  const handleFilterRequest = (
    filterValues: Filter | DynamicValue | null,
    filterName?: string
  ): void => {
    const updatedFilterName = filterName || '';
    const filter = {
      filterValues,
      filterName: updatedFilterName,
    };
    setUpdatedSelectedFilter(filter);
    setSelectedFilter(filter);
    if (filterValues) {
      const filters = getFilterApiValue(filterValues);
      setSelectedFilterApiValues(filters);
      delete filters.search;
      handleRefetchItems(filters);
      dispatch(setInventoryReturnsFilters(JSON.stringify(filter)));
    } else {
      setSelectedFilterApiValues(null);
      handleRefetchItems(null);
    }
  };

  const handleNewReturn = (): void => {
    setOpenNewReturnModal(!openNewReturnModal);
  };

  const handleNewReturnsActionDropdownSelect = (value: any): void => {
    setReturnsType(value.label);
    setOpenNewReturnModal(!openNewReturnModal);
  };

  const handleCancelButton = (): void => {
    setCancelModalVisible(!cancelModalVisible);
  };

  const handleCancelModal = (): void => {
    setCancelModalVisible(!cancelModalVisible);
  };

  const handleCancelModalConfirmPress = (): void => {
    setCancelModalVisible(!cancelModalVisible);
    handleNewReturn();
  };

  const setReturnSearch = (searchedItem: string): void => {
    setOffsetReturns(0);
    setOffsetCompleted(0);
    if (searchedItem.length >= 3) {
      if (status === 'FAILED') {
        getInventoryRequestListFailedItems({
          variables: {
            offset: 0,
            limit: LIMIT,
            orderType: 'INVENTORY_RETURN',
            screenType: status,
            filters: {
              productSearch: searchedItem,
            },
          },
        });
      } else if (status === 'COMPLETED') {
        getInventoryRequestListProgressItems({
          variables: {
            offset: 0,
            limit: LIMIT,
            orderType: 'INVENTORY_RETURN',
            screenType: 'PROCESSED',
            filters: {
              productSearch: searchedItem,
            },
          },
        });
      } else {
        getInventoryReturnListItems({
          variables: {
            offset: 0,
            limit: LIMIT,
            type: status,
            filters: {
              productSearch: searchedItem,
            },
          },
        });
      }
    } else {
      if (status === 'FAILED') {
        getInventoryRequestListFailedItems({
          variables: {
            offset: 0,
            limit: LIMIT,
            orderType: 'INVENTORY_RETURN',
            screenType: status,
          },
        });
      } else if (status === 'COMPLETED') {
        getInventoryRequestListProgressItems({
          variables: {
            offset: 0,
            limit: LIMIT,
            orderType: 'INVENTORY_RETURN',
            screenType: 'PROCESSED',
          },
        });
      } else {
        getInventoryReturnListItems({
          variables: {
            offset: 0,
            limit: LIMIT,
            type: status,
          },
        });
      }
    }
  };

  const debouncedFetchReturnItems = useCallback(debounced(500, setReturnSearch), [
    debounced,
    setReturnSearch,
  ]);

  const handleSearch = useCallback(
    (_event: { persist: () => void }, searchedItem: any) => {
      const { value } = searchedItem;
      _event.persist();
      if (value && value.length >= 3) {
        debouncedFetchReturnItems(value);
      } else {
        debouncedFetchReturnItems(value);
      }
    },
    [debouncedFetchReturnItems]
  );
  const getFormattedList = useCallback((items: any[]): any[] => {
    if (items && items.length > 0) {
      return items.map((item: any) => {
        return {
          ...item,
          id: item.id || item.orderId,
          userHoldReasons: getFormattedHoldReasons(item.userHoldReasons),
          createdDate: item.createdDate ? moment(item.createdDate).format('L') : null,
          returnExpiryDate: item.returnExpiryDate
            ? moment(item.returnExpiryDate).format('L')
            : null,
          account: `${item.accountNumber} - ${item.accountName}`,
        };
      });
    }
    return [];
  }, []);

  const returnsFromQuery = useMemo(() => {
    if (inventoryReturnItems?.getInventoryReturnList) {
      return getFormattedList(inventoryReturnItems.getInventoryReturnList);
    }
    return [];
  }, [inventoryReturnItems?.getInventoryReturnList, getFormattedList]);

  const failedReturnsFromQuery = useMemo(() => {
    if (inventoryRequestFailedItems?.getOrderList) {
      return getFormattedList(inventoryRequestFailedItems.getOrderList);
    }
    return [];
  }, [inventoryRequestFailedItems?.getOrderList, getFormattedList]);

  const returnItems = returnsFromQuery;
  const returnFailedItems = failedReturnsFromQuery;

  let offsetData = offsetReturns;
  if (status === 'RETURNS') {
    offsetData = offsetReturns;
  } else if (status === 'COMPLETED') {
    offsetData = offsetCompleted;
  } else if (status === 'FAILED') {
    offsetData = offsetFailed;
  }

  const handleEditFilter = (editFilter: boolean): void => {
    setIsEditFilter(editFilter);
  };

  const handleEditPress = (filter: FilterPreset, isEditPress: boolean): void => {
    setSelectedFilter(filter);
    setFilterEventModalVisible(!filterEventModalVisible);
    setOpenReturnFilter(!openReturnFilter);
    if (isEditPress) {
      handleEditFilter(true);
    }
  };

  const handleFilterEvents = (
    filterValues: Filter | DynamicValue | null,
    filterName?: string
  ): void => {
    const updatedFilterName = filterName || '';
    const filter = {
      filterValues,
      filterName: updatedFilterName,
    };
    setUpdatedSelectedFilter(filter);
    setSelectedFilter(filter);
    if (filterValues) {
      const filters = getFilterApiValue(filterValues);
      setSelectedFilterApiValues(filters);
      dispatch(setInventoryReturnsFilters(JSON.stringify(filter)));
      handleRefetchItems(filters);
    } else {
      resetFilters();
    }
  };

  const resetFilters = useCallback((): void => {
    setIsManualPagination(false); // NEW
    setIsFilteredApply(false); // NEW
    setReturnCompletedItems([]); // NEW

    setSelectedFilter(null);
    setUpdatedSelectedFilter(null);
    setIsEditFilter(false);
    setSelectedFilterApiValues(null);
    handleRefetchItems(null);
    dispatch(clearInventoryReturnsFilters());
  }, [status, handleRefetchItems, dispatch]);

  const handleDeleteFilterPreset = (externalId: string): void => {
    const filterExternalId = selectedFilter ? selectedFilter.filterExternalId : null;
    if (filterExternalId && filterExternalId === externalId) {
      resetFilters();
    }
  };

  const handleToggleFilterEvent = (): void => {
    setIsEditFilter(false);
    setSelectedFilter(updatedSelectedFilter);
    setFilterEventModalVisible(!filterEventModalVisible);
    setOpenReturnFilter(!openReturnFilter);
  };

  const isFirstPage =
    // Case 1: No data
    !returnCompletedItems ||
    returnCompletedItems.length === 0 ||
    // Case 2, data is available
    offsetCompleted === 0;
  const isLastPage =
    // Case 1: No data
    !returnCompletedItems ||
    returnCompletedItems.length === 0 ||
    // Case 2: When no filter is applied (pagination mode) and fewer than 50 records are loaded on this page
    // ToDo: improve logic to fetch 51 record and apply the logic
    (!selectedFilter && returnCompletedItems.length < LIMIT - 1) ||
    // Case 3: when selectedFilter is applied (all data is fetched at once)
    (selectedFilter && returnCompletedItems.length <= offsetCompleted + (LIMIT - 1)) ||
    false;

  const returnCompletedItemsModified = useMemo(() => {
    // Return original data if no items or no filters
    if (!returnCompletedItems || returnCompletedItems.length === 0) {
      return [];
    }

    const filters = getFilterApiValue(selectedFilter?.filterValues);

    let modified = [...returnCompletedItems];

    // If no filters, return original paginated list
    if (!filters?.status) {
      // Paginatino limit of 50 returning more then 50 some time .
      return paginateData(returnCompletedItems, 0, LIMIT + 50);
    }

    const { sortDirection = 'asc', property = 'caseNumber' } = sortColumn ?? {};

    // Apply sorting
    modified = inventoryHelper.sortDetailsOnFrontEnd(modified, {
      orderBy: property,
      orderSortType: sortDirection,
    });

    // Paginate
    return paginateData(modified, offsetData, LIMIT);
  }, [returnCompletedItems, selectedFilter, sortColumn, offsetData]);

  return (
    <IconSettings iconPath="/icons">
      <ReturnHeader
        selectedFilterApiValues={selectedFilterApiValues}
        handleSearch={handleSearch}
        handleReturnsFilter={handleReturnsFilter}
        handleNewReturnsActionDropdownSelect={handleNewReturnsActionDropdownSelect}
        filterPresets={filterData}
        onEditPress={handleEditPress}
        handleFilterEvents={handleFilterEvents}
        resetFilters={resetFilters}
        // totalItems: If you are adding other pages for this logic,
        // make a common condition to pass all data object and return length of it
        totalItems={
          status === 'COMPLETED'
            ? returnCompletedItems?.length || 0
            : status === 'FAILED'
            ? returnFailedItems?.length || 0
            : status === 'RETURNS'
            ? returnItems?.length || 0
            : 0
        }
        status={status}
      />
      {selectedFilter && selectedFilter.filterValues && !isEditFilter && (
        <FilterTags selectedFilter={selectedFilter} handleFilter={handleFilterRequest} />
      )}
      <Tabs
        variant="scoped"
        id="inventory-tabs-scoped"
        selectedIndex={status === 'COMPLETED' ? 2 : status === 'FAILED' ? 1 : 0}
        onSelect={(e: any): void => handleCompletedTab(e)}
      >
        <TabsPanel className={'active'} label="Open">
          {returnItems && returnItems?.length > 0 ? (
            <ReturnDataTable
              data={returnItems || []}
              offsetData={offsetData}
              type="Returns"
              sortOrderList={getInventoryReturnListItems}
              sortedcolumn={sortedcolumn}
              filters={getFilterApiValue(selectedFilter?.filterValues)}
            />
          ) : (
            <>
              <div className="no-data-found-container">
                <h1 className="no-data-found-text">No Records Found</h1>
              </div>
            </>
          )}
        </TabsPanel>
        <TabsPanel label="Failed">
          {returnFailedItems && returnFailedItems.length > 0 ? (
            <ReturnDataTable
              data={returnFailedItems || []}
              offsetData={offsetData}
              type="Failed"
              sortOrderList={getInventoryRequestListFailedItems}
              sortedcolumn={sortedcolumn}
              filters={getFilterApiValue(selectedFilter?.filterValues)}
            />
          ) : (
            <div className="no-data-found-container">
              <h1 className="no-data-found-text">No Records Found</h1>
            </div>
          )}
        </TabsPanel>
        <TabsPanel label="Processed">
          {returnCompletedItemsModified && returnCompletedItemsModified.length > 0 ? (
            <ReturnDataTable
              data={returnCompletedItemsModified || []}
              offsetData={offsetData}
              type="Completed"
              sortOrderList={getInventoryRequestListProgressItems}
              sortedcolumn={sortedcolumn}
              filters={getFilterApiValue(selectedFilter?.filterValues)}
            />
          ) : (
            <div className="no-data-found-container">
              <h1 className="no-data-found-text">No Records Found</h1>
            </div>
          )}
        </TabsPanel>
      </Tabs>
      <div>
        {status === 'FAILED' && (
          <div className="slds-grid slds-grid_align-center slds-grid_vertical-align-center slds-p-top_medium">
            <div className="slds-col">
              <Button
                assistiveText={{ icon: 'Icon Bare Small' }}
                iconCategory="utility"
                iconName="chevronleft"
                iconSize="small"
                disabled={!(offsetFailed > 0)}
                iconVariant="bare"
                onClick={(): void => handlePaginationButtonClicked(PREV_DATA)}
                variant="icon"
              />
            </div>
            <div className="slds-col slds-p-left_medium slds-p-right_medium">
              <span>{`${offsetFailed + 1} - ${offsetFailed + LIMIT}`}</span>
            </div>
            <div className="slds-col">
              <Button
                assistiveText={{ icon: 'Icon Bare Small' }}
                iconCategory="utility"
                iconName="chevronright"
                iconSize="small"
                iconVariant="bare"
                disabled={returnFailedItems && returnFailedItems?.length < LIMIT}
                onClick={(): void => handlePaginationButtonClicked(NEXT_DATA)}
                variant="icon"
              />
            </div>
          </div>
        )}
        {status === 'RETURNS' && (
          <div className="slds-grid slds-grid_align-center slds-grid_vertical-align-center slds-p-top_medium">
            <div className="slds-col">
              <Button
                assistiveText={{ icon: 'Icon Bare Small' }}
                iconCategory="utility"
                iconName="chevronleft"
                iconSize="small"
                disabled={!(offsetReturns > 0)}
                iconVariant="bare"
                onClick={(): void => handlePaginationButtonClicked(PREV_DATA)}
                variant="icon"
              />
            </div>
            <div className="slds-col slds-p-left_medium slds-p-right_medium">
              <span>{`${offsetReturns + 1} - ${offsetReturns + LIMIT}`}</span>
            </div>
            <div className="slds-col">
              <Button
                assistiveText={{ icon: 'Icon Bare Small' }}
                iconCategory="utility"
                iconName="chevronright"
                iconSize="small"
                iconVariant="bare"
                disabled={returnItems && returnItems?.length < LIMIT}
                onClick={(): void => handlePaginationButtonClicked(NEXT_DATA)}
                variant="icon"
              />
            </div>
          </div>
        )}
        {status === 'COMPLETED' && (
          <div className="slds-grid slds-grid_align-center slds-grid_vertical-align-center slds-p-top_medium">
            <div className="slds-col">
              <Button
                assistiveText={{ icon: 'Icon Bare Small' }}
                iconCategory="utility"
                iconName="chevronleft"
                iconSize="small"
                disabled={isFirstPage}
                iconVariant="bare"
                onClick={(): void => handlePaginationButtonClicked(PREV_DATA)}
                variant="icon"
              />
            </div>
            <div className="slds-col slds-p-left_medium slds-p-right_medium">
              <span>{`${offsetCompleted + 1} - ${offsetCompleted + LIMIT}`}</span>
            </div>
            <div className="slds-col">
              <Button
                assistiveText={{ icon: 'Icon Bare Small' }}
                iconCategory="utility"
                iconName="chevronright"
                iconSize="small"
                iconVariant="bare"
                disabled={isLastPage}
                // disabled={returnCompletedItems && returnCompletedItems?.length == 0}
                onClick={(): void => handlePaginationButtonClicked(NEXT_DATA)}
                variant="icon"
              />
            </div>
          </div>
        )}
        {openReturnFilter && (
          <InventoryReturnFilter
            pathname={pathname}
            type={status}
            selectedFilter={selectedFilter}
            handleFilterRequest={handleFilterRequest}
            isOpen={openReturnFilter}
            toggleOpen={handleFilterModal}
            isRequest={false}
            handleToggleFilterEvent={handleToggleFilterEvent}
            refetchFilterPresets={refetchFilterPresets}
            handleFilterEvents={handleFilterEvents}
            handleEditFilter={handleEditFilter}
            isEditFilter={isEditFilter}
            handleClearFilter={handleDeleteFilterPreset}
          />
        )}
        {/* {openReturnCompletedFilter && (
          <InventoryReturnFilter
            pathname={pathname}
            type={status}
            selectedFilter={selectedFilter}
            handleFilterRequest={handleFilterRequest}
            isOpen={openReturnCompletedFilter}
            toggleOpen={handleRequestCompletedFilterModal}
            isRequest={false}
            handleToggleFilterEvent={handleToggleFilterEvent}
            refetchFilterPresets={refetchFilterPresets}
            handleFilterEvents={handleFilterEvents}
            handleEditFilter={handleEditFilter}
            isEditFilter={isEditFilter}
            handleClearFilter={handleDeleteFilterPreset}
          />
        )} */}
        {openNewReturnModal && (
          <InventoryReturn
            isOpen={openNewReturnModal}
            toggleOpen={handleNewReturn}
            formData={data}
            eventType="Return Inventory"
            returnsType={returnsType}
            handleCancelButton={handleCancelButton}
            apiData={salesRepsItems}
          />
        )}
        {cancelModalVisible && (
          <CancelEventModal
            isReturn
            canceModalVisible={cancelModalVisible}
            handleCancelModal={handleCancelModal}
            handleCancelModalConfirmPress={handleCancelModalConfirmPress}
          />
        )}
      </div>
      {isLoading && (
        <Spinner
          size="large"
          variant="base"
          assistiveText={{ label: 'Loading...' }}
          key="spinner"
        />
      )}{' '}
    </IconSettings>
  );
};

export default withRouter(InventoryReturns);
